import { Base, Langs } from 'zf-web-components';
import { useApp } from '../hooks';
import type { ReactElement } from 'react';
import type { ThemeConfigProps } from './types';

export function ThemeConfig(props: ThemeConfigProps): ReactElement {
  const { theme } = useApp();
  return (
    <Base.ConfigProvider theme={theme} locale={Langs[props.store.local.lang as keyof typeof Langs].locale}>
      {props.children}
    </Base.ConfigProvider>
  );
}
